import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import IconStatusCheck from '../../assets/icons/IconStatusCheck';
import IconStatusWarn from '../../assets/icons/IconStatusWarn';

class CollapseInformationFromSales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpened: false
        }
    }

    handleCollapse = () => {
        this.setState({
            isOpened: !this.state.isOpened
        })
    }

    render() {
        return (
            <div className="text-sm border-b-2 border-gray-500 p-5">
                <div className="flex items-center justify-between cursor-pointer select-none" id="btninformationcollapse" onClick={() => this.handleCollapse()}>
                    <p>Informasi dari Sales</p>
                    <FontAwesomeIcon icon={this.state.isOpened ? faChevronUp : faChevronDown} className="text-darkblue" />
                </div>
                <div className={!this.state.isOpened ? "hidden" : null}>
                    <div className="flex justify-between items-center mt-5 mb-3">
                        <p>Kode NS</p>
                        <p>{this.props.data.ns_code === "" ? "-" : this.props.data.ns_code}</p>
                    </div>
                    <div className="flex justify-between items-center mb-3">
                        <p>Kode Cabang</p>
                        <p>{this.props.data.branch_id === "" ? "-" : this.props.data.branch_id}</p>
                    </div>
                    <div className="flex justify-between items-center mb-3">
                        <p>Status</p>
                        {this.props.data.license_status === "" && <div className="flex items-center">-</div>}
                        {this.props.data.license_status === "A" && <div className="flex items-center">
                            <IconStatusCheck />
                            <p className="ml-1">Aktif</p>
                        </div>}
                        {this.props.data.license_status === "E" && <div className="flex items-center">
                            <IconStatusWarn />
                            <p className="ml-1">Kadaluwarsa</p>
                        </div>}
                        {this.props.data.license_status === "D" && <div className="flex items-center">
                            <IconStatusWarn />
                            <p className="ml-1">Terhapus</p>
                        </div>}
                    </div>
                </div>
            </div>
        );
    }
}

export default CollapseInformationFromSales;